define('viewmodels/modals/dialogs/NotificationsDialog',['knockout'], function (ko) {

    var NotificationsDialog = function(dialog, actionProvider, title, notifications) {
        this.title = title;
        this.dialog = dialog;
        this.notifications = notifications;
        this.actionProvider = actionProvider;
    };

    NotificationsDialog.prototype.close = function() {
        this.dialog.close(this);
    };
    
    NotificationsDialog.prototype.doAction = function(notification) {
        var action = ko.unwrap(notification.notification.actions)[0];
        if (action && notification.notification.isActionable()) {
            this.actionProvider.getNotificationAction(action.action, ko.unwrap(notification.parameters))
                .onClick()
                .then(this.close.bind(this));
        }
    };

    return NotificationsDialog;
});

